/** A custom key-value field attached to a participant (My Information tab). */
export default class ParticipantExtraInformation {
  public static createEmpty(): ParticipantExtraInformation {
    return new ParticipantExtraInformation();
  }

  constructor(
    public Id: number = 0,
    public ParticipantId: number = 0,
    public ApplicationInstanceId: number = 0,
    public KeyValue: string = '',
    public KeyInformation: string = '',
    public EventId: number = 0,
    public SortOrder: number = 0,
    public Source: string = '',
    public IsVisibleInApp: boolean = false,
    public ParticipantsCount: number = 0,
    public IsDeleted: boolean = false,
  ) {}
}

